export function Reviews() {
  const reviews = [
    {
      name: 'Sarah L.',
      image: 'https://static.readdy.ai/image/23ade0805c842f9b7ab135282ab65771/611781ce2d47894a36275326075f1aff.png',
      rating: 5,
      text: 'Dr. Yousefi is an amazing doctor! He took the time to listen to my concerns and provided a treatment plan that worked wonders for my chronic pain. I\'m finally able to enjoy daily activities again.'
    },
    {
      name: 'Mark H.',
      image: 'https://static.readdy.ai/image/23ade0805c842f9b7ab135282ab65771/2d59a221b0e604a348d7047ee16fdfc8.png',
      rating: 5,
      text: 'After years of suffering from migraines, Dr. Yousefi\'s approach finally brought me relief. His personalized care and professionalism were outstanding.'
    },
    {
      name: 'Emily T.',
      image: 'https://static.readdy.ai/image/23ade0805c842f9b7ab135282ab65771/69737d8a0708242008aa851794a04eb8.png',
      rating: 5,
      text: 'I can\'t thank Dr. Yousefi enough for helping me manage my neurological condition. His compassionate care made all the difference in my treatment journey.'
    }
  ];

  return (
    <section id="reviews" className="py-24 px-6 bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white text-center mb-16">
          What Patients Are Saying
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-8 hover:bg-slate-800/70 transition-all duration-300 border border-white/5 hover:border-emerald-500/30"
            >
              <div className="flex flex-col items-center mb-6">
                <div className="w-24 h-24 rounded-full overflow-hidden mb-4 ring-4 ring-emerald-500/30">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  {review.name}
                </h4>
                <div className="flex gap-1">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-slate-300 text-center leading-relaxed">
                {review.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
